// extracted by mini-css-extract-plugin
export var root = "continuing-through-today-module--root--1mB96";